import { message } from 'antd'
import api from 'api'
import { SimpleCustomerForm } from 'components/models/customers'
import { Button } from 'components/shared/Button'
import { useAuth } from 'contexts/auth'
import { useCustomerRegistered } from 'hooks/customers'
import router from 'next/router'
import { useTranslation } from 'next-i18next'
import MailIcon from 'public/icons/mail.svg'
import { CSSProperties, FC, useCallback, useState } from 'react'

type Props = {
  ownerId: string
  title?: string
  showIcon?: boolean
  style?: CSSProperties
}

export const MessageButton: FC<Props> = ({
  ownerId,
  title,
  showIcon = false,
  style,
}) => {
  const { t } = useTranslation()
  const { user, isAuthenticated, setSignInNotification, setIsSignInOpened } =
    useAuth()
  const { data: customerRegistered, mutate: mutateCustomerRegistered } =
    useCustomerRegistered({ ownerId: ownerId, isReady: !!user })

  const buttonLabel = title || t('メッセージ')
  const [loading, setLoading] = useState(false)
  const [visibleCustomerRegister, setVisibleCustomerRegister] = useState(false)

  const transitionMessageRoom = useCallback(async () => {
    setLoading(true)
    const { data: messageRoom, error }: { data: { id: string }; error: any } =
      await api.get(`/owners/${ownerId}/message_room`)
    if (error) {
      message.error(error.data.error)
      setLoading(false)
      return
    }
    router.push(`/messages/${messageRoom.id}`)
    setLoading(false)
  }, [ownerId])

  const onClick = useCallback(async () => {
    if (!isAuthenticated) {
      setSignInNotification(
        t('メッセージを送るには、ArtXにログインしてください。'),
      )
      setIsSignInOpened(true)
      setLoading(false)
      return
    }
    // 初めてギャラリーとメッセージする前には取引先登録する
    if (!customerRegistered) {
      setVisibleCustomerRegister(true)
      message.success(t('ギャラリーとメッセージを開始するには登録が必要です。'))
      return
    }
    await transitionMessageRoom()
  }, [
    isAuthenticated,
    customerRegistered,
    transitionMessageRoom,
    setSignInNotification,
    t,
    setIsSignInOpened,
  ])

  return (
    <Button
      loading={loading}
      type="primary"
      size="md"
      style={{ display: 'flex', alignItems: 'center', ...style }}
      onClick={onClick}
    >
      {showIcon && (
        <MailIcon
          style={{ width: '14px', height: '14px', marginRight: '4px' }}
        />
      )}
      {buttonLabel}
      {visibleCustomerRegister && (
        <SimpleCustomerForm
          visible={visibleCustomerRegister}
          setVisible={setVisibleCustomerRegister}
          mutateCustomer={mutateCustomerRegistered}
          ownerId={ownerId}
          user={user}
          afterFinish={transitionMessageRoom}
        />
      )}
    </Button>
  )
}
